import * as React from "react"

const SvgRecPerson = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12 12.429q-1.65 0-2.825-1.175T8 8.429c0-1.65.392-2.042 1.175-2.825Q10.35 4.429 12 4.429c1.65 0 2.042.391 2.825 1.175Q16 6.779 16 8.429c0 1.65-.392 2.041-1.175 2.825Q13.65 12.429 12 12.429m0-2q.825 0 1.412-.588Q14 9.254 14 8.429t-.588-1.413A1.93 1.93 0 0 0 12 6.43q-.825 0-1.412.587A1.93 1.93 0 0 0 10 8.43q0 .825.588 1.412.587.588 1.412.588Z"
      clipRule="evenodd"
    />
    <path d="M4 18.429v-.8q0-.85.438-1.563A2.9 2.9 0 0 1 5.6 14.979a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 12 13.43a13.8 13.8 0 0 1 3.657.492 3 3 0 0 0-.364.307L13.93 15.59a11.5 11.5 0 0 0-4.705.175A13 13 0 0 0 6.5 16.778a.97.97 0 0 0-.5.85v.8h7v2H6q-.824 0-1.412-.588A1.93 1.93 0 0 1 4 18.43Zm11.949 3a.91.91 0 0 1-.67-.28.91.91 0 0 1-.279-.669v-2.846q0-.143.06-.273a.8.8 0 0 1 .153-.225l1.495-1.494a.72.72 0 0 1 .498-.213q.308 0 .533.237t.166.604l-.154.89h2.466q.202 0 .338.136a.46.46 0 0 1 .137.338v.593a.8.8 0 0 1-.048.26l-1.067 2.515a.65.65 0 0 1-.267.314.75.75 0 0 1-.397.113z" />
  </svg>
)
export default SvgRecPerson
